"use client"

import { motion } from "framer-motion"
import { useInView } from "@/hooks/use-in-view"

interface FadeInProps {
  children: React.ReactNode
  delay?: number
  direction?: "up" | "down" | "left" | "right" | "none"
  duration?: number
  className?: string
  once?: boolean
}

export default function FadeIn({
  children,
  delay = 0,
  direction = "up",
  duration = 0.7,
  className = "",
  once = true,
}: FadeInProps) {
  const { ref, inView } = useInView({ threshold: 0.1 })

  const directionMap = {
    up:    { y: 28,  x: 0 },
    down:  { y: -28, x: 0 },
    left:  { y: 0,   x: -36 },
    right: { y: 0,   x: 36 },
    none:  { y: 0,   x: 0 },
  }

  const initial = { opacity: 0, ...directionMap[direction] }
  const animate = inView ? { opacity: 1, y: 0, x: 0 } : initial

  return (
    <motion.div
      ref={ref}
      initial={initial}
      animate={animate}
      transition={{
        duration,
        delay,
        ease: [0.16, 1, 0.3, 1],
      }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
